import { AidBreakdown, NormalizedStudentProfile } from "./types";
import { POST_2026_POLICY } from "./policyVersions";
import { estimateEducationCosts } from "./estimateEducationCosts";
import { estimateNeed } from "./estimateNeed";

function roundToTwo(value: number): number {
  return Math.round(value * 100) / 100;
}

export function estimateAidPost2026(
  profile: NormalizedStudentProfile
): AidBreakdown {
  const policy = POST_2026_POLICY;
  const costs = estimateEducationCosts(profile, policy);
  const { need } = estimateNeed(profile, costs, policy);

  // 2025-26 rates: $525/week single, $865/week with dependants.
  const hasWeeklyDependantRate =
    profile.status !== "single" || profile.dependants.hasDependants;

  const weeklyMax = hasWeeklyDependantRate
    ? policy.weeklyMaxWithDependants
    : policy.weeklyMaxSingle;

  const weeklyCapApplied = weeklyMax * profile.study.studyWeeks;

  const cappedAid = Math.min(need.calculatedNeed, weeklyCapApplied);
  const grants = roundToTwo(cappedAid * policy.grantShare);
  const loans = roundToTwo(cappedAid * policy.loanShare);
  const unmetNeed = roundToTwo(Math.max(0, need.calculatedNeed - cappedAid));

  return {
    policyId: policy.id,
    policyName: policy.name,
    totalAid: roundToTwo(cappedAid),
    grants,
    loans,
    unmetNeed,
    weeklyCapApplied: roundToTwo(weeklyCapApplied),
  };
}